import React, { useEffect, useRef, useState } from 'react';
import Main from '../Main';
import { Button, Col, Dropdown, Form, Modal, ProgressBar, Row } from 'react-bootstrap';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import '../../assets/css/usermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbFilterBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
import UserManagementTable from './UserManagementTable';
import SbDropdownButton from '../Buttons/SbDropdownButton';
import AddUserModal from './AddUserModal';
import Download from '../MainSection/Download/Download';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewUserModal from './ViewUserModal';
import AddSlocModal from './AddSlocModal';
import UserValueFilterModal from './UserValueFilterModal';
import UserColumnFilterModal from './UserColumnFilterModal';
import crossmark from '../../assets/images/CustomerManagement/crossmark.svg';
import xlsImg from '../../assets/images/UserManagement/xls-img.svg';
import { useDispatch, useSelector } from 'react-redux';
import { loadCustomFieldsForUser, loadSingleUserManagementData, loadUserCustomFieldData, loadUserManagementData } from '../../redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import moment from 'moment';

const UserManagement = () => {

    let dispatch = useDispatch();
    let location = useLocation();
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

    const { userData } = useSelector((state) => state.data);
    const { singleUserData } = useSelector((state) => state.data);
    // const { modulePermissions } = useSelector((state) => state.data);
    const { getUserCustomFields } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [openSlocModal, setOpenSlocModal] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [files, setFiles] = useState([]);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [progress, setProgress] = useState([]);
    const [droppedFile, setDroppedFile] = useState(null);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [userID, setUserID] = useState("")
    const [selectedColumns, setSelectedColumns] = useState([
        "ID", "NAME", "Email.ID", "HOME ADDRESS", "WORK ADDRESS", "CONTACT", "JOINING DATE",
        "ROLE", "REPORTING TO", "STATUS", "SET SLOC", "ACTION"
    ]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchParams, setSearchParams] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const fileInputRef = useRef(null);
    const [customFields, setCustomFields] = useState([]);

    const userManagenemtData = () => {
        dispatch(loadUserManagementData(setLoading, searchQuery, searchParams));
    }

    useEffect(() => {
        userManagenemtData();
    }, [searchQuery, searchParams]);

    useEffect(() => {
        if (fromDate && toDate) {
            // Format the dates using moment.js
            const formattedFromDate = moment(fromDate).format('DD-MMM-YYYY'); // e.g., 01-Jan-2025
            const formattedToDate = moment(toDate).format('DD-MMM-YYYY');     // e.g., 15-Jan-2025

            // Build the WHERE clause with formatted dates
            const whereClause = `CONVERT(DATE,U.Users_DOJ,101) >= CONVERT(DATE,'${formattedFromDate}',101) AND CONVERT(DATE,U.Users_DOJ,101) <= CONVERT(DATE,'${formattedToDate}',101)`;

            // Update the searchParams state with the final WHERE clause
            setSearchParams(whereClause);
        } else {
            // Clear date filter if no dates are selected
            setSearchParams('');
        }
    }, [fromDate, toDate]); // The dependencies include fromDate, toDate, and searchText    

    useEffect(() => {
        dispatch(loadCustomFieldsForUser());
    }, [])

    useEffect(() => {
        if (getUserCustomFields) {
            setCustomFields(getUserCustomFields);
        }
    }, [getUserCustomFields]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleOpenModal = (userId) => {
        setIsModalOpen(true);
        if (userId) {
            dispatch(loadSingleUserManagementData(userId));
            setUserID(userId);
        } else {
            setUserID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenViewModal = (userId) => {
        setViewModal(true);
        if (userId) {
            dispatch(loadSingleUserManagementData(userId));
            setUserID(userId);
        } else {
            setUserID("");
        }
    };

    const handleCloseViewModal = () => {
        setViewModal(false);
    };
    const handleOpenSloc = (userId) => {
        setOpenSlocModal(true);
        if (userId) {
            dispatch(loadSingleUserManagementData(userId));
            setUserID(userId);
        } else {
            setUserID("");
        }
    };

    const handleCloseSlocModal = () => {
        setOpenSlocModal(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }
    const handleCloseViewDetails = () => {
        setShowCustomerViewDetails(false);
    }
    const [showAddUserModa, setAddUserModal] = useState(false)
    const openAddModal = () => {
        setAddUserModal(true);
    };

    const handleOpenBulkUploadModal = () => {
        // Reset the state before opening the modal
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
        setShowBulkUploadModal(true);
    };

    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        // Reset states when closing the modal if needed
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
    };

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        processFiles(newFiles);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const newFiles = Array.from(event.dataTransfer.files);
        processFiles(newFiles);

        if (newFiles.length > 0) {
            setDroppedFile(newFiles[0]);
        }
    };

    const processFiles = (newFiles) => {
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        setProgress((prevProgress) => [
            ...prevProgress,
            ...newFiles.map(() => 0)
        ]);
        simulateProgress(newFiles.length);
    };

    const simulateProgress = (newFileCount) => {
        const currentFileIndex = files.length;
        for (let i = 0; i < newFileCount; i++) {
            let progressValue = 0;
            const interval = setInterval(() => {
                if (progressValue >= 100) {
                    clearInterval(interval);
                    setUploadComplete(true); // Set completion status
                    return;
                }
                progressValue += 10;
                setProgress((prevProgress) => {
                    const newProgress = [...prevProgress];
                    newProgress[currentFileIndex + i] = progressValue;
                    return newProgress;
                });
            }, 500);
        }
    };

    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setProgress((prevProgress) => prevProgress.filter((_, i) => i !== index));
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    const navigate = useNavigate();
    const handleAnalyticsClick = () => {
        navigate('/licenceDashboard')
    }

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(null);
        setToDate(null);
        userManagenemtData();
    }

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = userData?.map(item => ({
            "ID": item.UserID || "NA",
            "NAME": item.FirstName || "NA",
            "Email.ID": item.EmailID || "NA",
            "ADDRESS": item.HomeAddress || "NA",
            "CONTACT": item.Phone || "NA",
            "ROLE": item.RoleName || "NA",
            "REPORTING TO": item.ReportingTo || "NA",
            "STATUS": item.Status || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Users");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'user_management.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("User Management Data", 14, 20);

        const dataToExport = userData?.map(item => ([
            item.UserID || "NA",
            item.FirstName || "NA",
            item.EmailID || "NA",
            item.HomeAddress || "NA",
            item.Phone || "NA",
            item.RoleName || "NA",
            item.ReportingTo || "NA",
            item.Status || "NA",
        ])) || [];

        const columns = [
            { title: "ID", dataKey: "id" },
            { title: "NAME", dataKey: "name" },
            { title: "Email.ID", dataKey: "emailId" },
            { title: "ADDRESS", dataKey: "address" },
            { title: "CONTACT", dataKey: "contact" },
            { title: "ROLE", dataKey: "role" },
            { title: "REPORTING TO", dataKey: "reportingRo" },
            { title: "STATUS", dataKey: "status" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'center',
            },
        });

        // Save PDF
        doc.save('user_management.pdf');
    };

    const handleDownloadWord = () => {
        if (!userData || userData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = userData.map(item => [
            String(item?.UserID || "NA"),  // Explicitly convert to string
            String(item?.FirstName || "NA"),  // Explicitly convert to string
            String(item?.EmailID || "NA"),  // Explicitly convert to string
            String(item?.HomeAddress || "NA"),  // Explicitly convert to string
            String(item?.Phone || "NA"),  // Explicitly convert to string
            String(item?.RoleName || "NA"),  // Explicitly convert to string
            String(item?.ReportingTo || "NA"),  // Explicitly convert to string
            String(item?.Status || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "ID", "NAME", "Email.ID", "ADDRESS", "CONTACT", "ROLE",
            "REPORTING TO", "STATUS",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "User Management System",
            title: "User Management Report",
            description: "A detailed report of user management.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "user_management.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!userData || userData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = userData.map(item => [
            item.UserID || "NA",
            item.FirstName || "NA",
            item.EmailID || "NA",
            item.HomeAddress || "NA",
            item.Phone || "NA",
            item.RoleName || "NA",
            item.ReportingTo || "NA",
            item.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "ID", "NAME", "Email.ID", "ADDRESS", "CONTACT", "ROLE",
            "REPORTING TO", "STATUS",
        ];

        // Create HTML table for printing
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>User Management Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>User Management Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!userData || userData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = userData.map(item => [
            item.UserID || "NA",
            item.FirstName || "NA",
            item.EmailID || "NA",
            item.HomeAddress || "NA",
            item.Phone || "NA",
            item.RoleName || "NA",
            item.ReportingTo || "NA",
            item.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "ID", "NAME", "Email.ID", "ADDRESS", "CONTACT", "ROLE",
            "REPORTING TO", "STATUS",
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'user_management_report.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    return (
        <div className="customer-management-container" >
            <Main>
                <div className='components-download-container'>
                    <Download
                        SignInType={signInDetails[0].SignInType}
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                <span>User Management &nbsp;({userData?.[0]?.AciveUser || 0}/{userData?.[0]?.CompanyLicense || 0})</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={4} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" onClick={handleSearchClick} />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            dropdownMode="select"
                                            placeholderText='From'
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            maxDate={new Date()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            dropdownMode="select"
                                            placeholderText='To'
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            maxDate={new Date()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                {/* <div className='customermanagement-header-btns add-btn' onClick={handleOpenModal}>
                                <Button><img src={add} alt="" className='filter-img' />Add User</Button>
                            </div> */}
                                {/* <SbAddBtn btnName="Add User" onClickEffect={handleOpenModal} /> */}
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {moduleData?.CanCreate === true && <SbDropdownButton
                                    openAddModal={() => { handleOpenModal("") }}
                                    pageName="User"
                                    btnName="Add User"
                                    addBulkModel={handleOpenBulkUploadModal}
                                />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <UserManagementTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                handleOpenViewModal={handleOpenViewModal}
                                handleOpenSloc={handleOpenSloc}
                                handleOpenValueFilterModal={handleOpenValueFilterModal}
                                userData={userData}
                                userID={userID}
                                loading={loading}
                                selectedColumns={selectedColumns}
                                moduleData={moduleData}
                            />
                        </div>
                    </div>
                </div>
            </Main>

            {/* Bulk Upload Modal */}
            <Modal
                show={showBulkUploadModal}
                onHide={handleCloseBulkUploadModal}
                centered
                size="lg"
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                className='add-customer-modal add-user-modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Bulk Upload</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="bulkFileInput">
                        {/* <Form.Label>Upload Files</Form.Label> */}
                        <div
                            className="drag-and-drop-area"
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={handleDrop}
                        >
                            <div className='drag-drop-container'>
                                {droppedFile ? (
                                    <>
                                        <div className="file-info">
                                            <span>{droppedFile.name}</span>&nbsp;&nbsp;
                                            {/* <img src={crossmark} alt="" className='bulk-upload-delete-img' onClick={() => {
                                                setDroppedFile(null); // Clear the dropped file
                                                removeFile(0); // Remove the file from files array if needed
                                            }} /> */}
                                        </div>
                                        {/* Progress bar for the dropped file */}
                                        <ProgressBar
                                            now={progress[0] || 0}
                                            label={`${progress[0] || 0}%`}
                                            variant={uploadComplete ? "success" : "danger"} // Change color based on completion
                                        />
                                        <div className='d-flex justify-content-between align-items-center pt-2'>
                                            <p> ({(droppedFile.size / (1024 * 1024)).toFixed(2)} MB)</p>
                                            <p style={{ color: uploadComplete ? "green" : "red" }}>{uploadComplete ? "Completed" : "Loading..."}</p>
                                        </div>
                                    </>
                                ) : (
                                    <div className='drag-drop-div'>
                                        <img src={xlsImg} alt="" className='xls-Img' />&nbsp;&nbsp;
                                        <p>Drag & Drop Excel file</p>
                                    </div>
                                )}
                            </div>
                            <div className='browse-btn-div'>
                                {!droppedFile && <SBSaveUpdateBtn btnName="Browse Files" onClickEffect={() => fileInputRef.current.click()} />}
                                <input
                                    type="file"
                                    multiple
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                            </div>
                        </div>
                    </Form.Group>

                    {/* Display files with progress bars */}
                    {/* {files.length > 0 && (
                        <div className="uploaded-files">
                            {files.map((file, index) => (
                                <div key={index} className="file-upload-progress">
                                    <div className="file-info">
                                        <span>{file.name}</span>&nbsp;&nbsp;
                                        <p> ({(file.size / (1024 * 1024)).toFixed(2)} MB)</p>
                                        <img src={crossmark} alt="" className='bulk-upload-delete-img' onClick={() => removeFile(index)} />
                                    </div>
                                    <ProgressBar now={progress[index]} label={`${progress[index]}%`} />
                                </div>
                            ))}
                        </div>
                    )} */}
                </Modal.Body>
                {droppedFile && <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseBulkUploadModal} />
                    <SBSaveUpdateBtn btnName="Bulk Upload" />
                </Modal.Footer>}
            </Modal>

            {
                isModalOpen && <AddUserModal
                    open={isModalOpen}
                    handleClose={handleCloseModal}
                    singleUserData={singleUserData}
                    userID={userID}
                    userManagenemtData={userManagenemtData}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                />
            }
            {
                viewModal && <ViewUserModal
                    viewModal={viewModal}
                    handleCloseViewModal={handleCloseViewModal}
                    singleUserData={singleUserData}
                    userID={userID}
                    customFields={customFields}
                    setLoading={setLoading}
                />
            }
            {
                openSlocModal && <AddSlocModal
                    openSlocModal={openSlocModal}
                    handleCloseSlocModal={handleCloseSlocModal}
                    singleUserData={singleUserData}
                    userID={userID}
                    userManagenemtData={userManagenemtData}
                />
            }
            {
                showColumnFilterModal && (
                    <UserColumnFilterModal
                        showColumnFilterModal={showColumnFilterModal}
                        handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                        selectedColumns={selectedColumns}
                        handleSaveColumns={handleColumnSelectionChange}
                    />
                )
            }
            {
                showValueFilterModal && (
                    <UserValueFilterModal
                        showValueFilterModal={showValueFilterModal}
                        handleCloseValueFilterModal={handleCloseValueFilterModal}
                    />
                )
            }
        </div >
    );
};

export default UserManagement;